<div appLabelStyle>
  {{ label() }}
</div>

<ng-content />
